import { render, staticRenderFns } from "./MailStudioDialog.vue?vue&type=template&id=0b30233e"
import script from "./MailStudioDialog.vue?vue&type=script&lang=js"
export * from "./MailStudioDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports